'use client';

import React, { useEffect } from 'react';

import { styles } from '.';
import PictureItem from '../PictureItem';
import { usePictureViewerContext } from 'providers/picture-viewer-provider';

type TProps = {
  pictures: any[];
  //
  lang: string;
};

const PictureViewer = (props: TProps) => {
  const { pictures } = props;

  const { setPictures, setSelector } = usePictureViewerContext();

  useEffect(() => {
    setPictures(pictures);
  }, [pictures, setPictures]);

  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        {pictures?.map((picture: any, index: number) => (
          <PictureItem
            key={`${picture.documentId}-${index}`}
            picture={picture}
            onClick={() => {
              setPictures(pictures);
              setSelector(index);
            }}
          />
        ))}
      </ul>
    </div>
  );
};

export default PictureViewer;
